import { FileTypeEnum as e, FileSourceEnum as o } from "@systemeio/types";
const t = {
  name: "systeme.io",
  colors: {
    oldBrandPrimary: "#00A0FF",
    oldTextPrimary: "#142D63",
    oldBackgroundPrimary: "#F1F4F8",
    oldBackgroundHeader: "#142D63"
  },
  favicon: {
    id: 0,
    name: "Favicon",
    filename: "Favicon",
    path: "https://d2543nuuc0wvdg.cloudfront.net/images/logo-compact-new.ico",
    thumbnail: null,
    source: o.WhiteLabel,
    size: 0,
    type: e.Image,
    createdAt: ""
  },
  logo: {
    id: 0,
    name: "Logo",
    filename: "Logo",
    path: "https://d2543nuuc0wvdg.cloudfront.net/images/logo-compact-new.svg",
    thumbnail: null,
    source: o.WhiteLabel,
    size: 0,
    type: e.Image,
    createdAt: ""
  },
  dashboardHostname: ""
};
export {
  t as defaultBrandSettings
};
